import {
  AdaptiveCard,
  Column,
  ColumnSet,
  Container,
  HostConfig,
  Image,
  OpenUrlAction,
  Size,
  SizeAndUnit,
  SizeUnit,
  SubmitAction,
  TextBlock,
  TextColor,
  TextSize,
  TextWeight
} from 'adaptivecards';
import hostConfig from './hostConfig.json';
export class BotFrameworkCardAction {
  __isBotFrameworkCardAction;
  cardAction;
}

function addCardAction(cardAction, includesOAuthButtons) {
  const { type } = cardAction;
  let action;

  if (
    type === 'imBack' ||
    type === 'messageBack' ||
    type === 'postBack' ||
    (type === 'signin' && includesOAuthButtons)
  ) {
    action = new SubmitAction();

    action.data = {
      __isBotFrameworkCardAction: true,
      cardAction
    };

    
  } else {
    action = new OpenUrlAction();
    action.url = cardAction.type === 'call' ? `tel:${cardAction.value}` : cardAction.value;
  }
  action.title = cardAction.title;
  action.iconUrl = cardAction.image;
  
  if (cardAction.channelData && cardAction.channelData.isNavigation) {
    // appends css class with name "style-{action.style lowercase}"
    action.style = "navigationbutton"
  }

  return action;
}

export default class CustomCardBuilder {
  card;
  container;
  styleOptions;
  constructor(styleOptions, direction = 'ltr') {

    this.card = new AdaptiveCard();

    // todo: explore styling possibilities 
    this.card.hostConfig = new HostConfig(hostConfig);
    this.container = new Container();
    this.container.rtl = direction === 'rtl';
    this.styleOptions = styleOptions;

    this.card.addItem(this.container);
  }

  addColumnSet(sizes, container = this.container, selectAction) {
    const columnSet = new ColumnSet();

    columnSet.selectAction = selectAction && addCardAction(selectAction);
    container.addItem(columnSet);

    return sizes.map(size => {
      const column = new Column();

      column.width = new SizeAndUnit(size, SizeUnit.Weight);

      columnSet.addColumn(column);

      return column;
    });
  }

  addItems(cardElements, container = this.container) {
    cardElements.forEach(cardElement => container.addItem(cardElement));
  }

  addTextBlock(text, template, container = this.container) {
    if (typeof text !== 'undefined') {
      const textblock = new TextBlock();

      // tslint:disable-next-line:forin
      for (const prop in template) {
        textblock[prop] = template[prop];
      }
      textblock.text = text;

      container.addItem(textblock);
    }
  }

  addButtons(cardActions, includesOAuthButtons) {
    cardActions &&
      cardActions.forEach(cardAction => {
        this.card.addAction(addCardAction(cardAction, includesOAuthButtons));
      });
  }

  addCommonHeaders(content) {
    const { richCardWrapTitle } = this.styleOptions;
    this.addTextBlock(content.title, {
      color: TextColor.Default,
      size: TextSize.Medium,
      weight: TextWeight.Bolder,
      wrap: richCardWrapTitle
    });
    this.addTextBlock(content.subtitle, { color: TextColor.Default, isSubtle: true, wrap: richCardWrapTitle });
    this.addTextBlock(content.text, { color: TextColor.Default, wrap: true });
  }

  addCommon(content) {
    this.addCommonHeaders(content);
    this.addButtons(content.buttons);
  }

  addImage(url, container, selectAction, altText) {
    container = container || this.container;

    const image = new Image();

    image.altText = altText;
    image.url = url;
    image.selectAction = selectAction && addCardAction(selectAction);
    image.size = Size.Stretch;

    container.addItem(image);
  }
}

export class ICommonContent {
  buttons;
  subtitle;
  text;
  title;
}
